import {Button, CTABanner} from '@primer/react-brand/esm'
import type {Document} from '@contentful/rich-text-types'
import {renderWithoutParagraphs} from '../../utils'
import type {Link} from '../../types'

export type FlexSuiteOutroCTAProps = {
  outroCtaHeading?: Document
  outroCtaDescription?: Document
  outroCtaOne?: Link
  outroCtaTwo?: Link
}

export function FlexSuiteOutroCTA({
  outroCtaHeading,
  outroCtaDescription,
  outroCtaOne,
  outroCtaTwo,
}: FlexSuiteOutroCTAProps) {
  return (
    <CTABanner>
      {outroCtaHeading ? <CTABanner.Heading>{renderWithoutParagraphs(outroCtaHeading)}</CTABanner.Heading> : null}
      {outroCtaDescription ? (
        <CTABanner.Description>{renderWithoutParagraphs(outroCtaDescription)}</CTABanner.Description>
      ) : null}
      {outroCtaOne?.fields.href && outroCtaTwo?.fields.href ? (
        <CTABanner.ButtonGroup>
          <Button as="a" href={outroCtaOne.fields.href}>
            {outroCtaOne.fields.text}
          </Button>
          <Button as="a" href={outroCtaTwo.fields.href} variant="secondary">
            {outroCtaTwo.fields.text}
          </Button>
        </CTABanner.ButtonGroup>
      ) : outroCtaOne?.fields.href ? (
        <CTABanner.ButtonGroup>
          <Button as="a" href={outroCtaOne.fields.href}>
            {outroCtaOne.fields.text}
          </Button>
        </CTABanner.ButtonGroup>
      ) : null}
    </CTABanner>
  )
}
